import type { IconSvgObject } from './types';

const AlignEndVerticalIcon: IconSvgObject = [
  ["path", { d: "M15 5L5 5C3.89543 5 3 5.89543 3 7V8C3 9.10457 3.89543 10 5 10H15C16.1046 10 17 9.10457 17 8V7C17 5.89543 16.1046 5 15 5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 14L11 14C9.89543 14 9 14.8954 9 16V17C9 18.1046 9.89543 19 11 19H15C16.1046 19 17 18.1046 17 17V16C17 14.8954 16.1046 14 15 14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 3L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default AlignEndVerticalIcon;
